import { filterHandler } from './filter';
import { queryBuilder } from './utils';

const fetchItems = async(page, body, parent) => {
  const media = document.getElementById('media');
  const pageKey = media.getAttribute('data-page-key');
  const pageSize = media.getAttribute('data-page-size');
  const filterUrl = media.getAttribute('data-filter-url');

  const params = new URLSearchParams({
    pageKey: pageKey,
    numberOfItemsPerPage: pageSize,
    searchTerm: body['media-search-input'],
    page: page,
    category: body.category,
    type: body.type,
  });

  try {
    const res = await fetch(filterUrl + '?' + params.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const htmlContent = await res.text();
    parent.innerHTML = htmlContent;
  } catch (error) {
    console.error(error);
  }

};

const onFilter = (body, mediaCards, page) => {
  queryBuilder(body);
  fetchItems(page, body, mediaCards);
};

const onLoadMore = (el, body, mediaCards) => {

  if (el.tagName === 'BUTTON' && el.hasAttribute('data-load-more')) {
    const nextPage = el.getAttribute('data-next-page');
    el.classList.add('button--progress');
    onFilter(body, mediaCards, nextPage);
    return;
  }
};

const onMediaLoad = () => {
  const media = document.getElementById('media');

  if (!media) return;
  const mediaCards = media.querySelector('[data-media-cards]');
  const mediaFilter = media.querySelector('[data-filter]');

  let body = {};
  filterHandler(mediaFilter, (data) => {
    body = data;
    onFilter(body, mediaCards, 1);
  });

  mediaCards?.addEventListener('click', (e) => onLoadMore(e.target, body, mediaCards));
};

export default onMediaLoad;
